/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon } from "@nordcloud/gnui";

export enum NOTIFICATION_ICON_STATUS {
  WARNING = "WARNING",
  INFO = "INFO",
  ERROR = "ERROR",
}

type Props = {
  type: NOTIFICATION_ICON_STATUS;
};

export function NotificationIcon({ type }: Props) {
  switch (type) {
    case NOTIFICATION_ICON_STATUS.WARNING:
      return <SVGIcon name="danger" color="warning" />;
    case NOTIFICATION_ICON_STATUS.INFO:
      return <SVGIcon name="info" color="notification" />;
    case NOTIFICATION_ICON_STATUS.ERROR:
      return <SVGIcon name="danger" color="danger" />;
    default:
      return null;
  }
}
